export default "__VITE_ASSET__dZBpNRXU__"